import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b2debaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "maintain-investigation-types" }
const _hoisted_2 = { class: "section-heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Maintain trust data", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Investigation types", -1))
const _hoisted_5 = { class: "search" }
const _hoisted_6 = { class: "search-inputs" }
const _hoisted_7 = { class: "search-bar" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-hm" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search fa-lg" })
], -1))
const _hoisted_9 = { class: "checkbox-button" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Show active only")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "space-filler",
  style: {"flex-grow":"1"}
}, null, -1))
const _hoisted_12 = { class: "investigation-types" }
const _hoisted_13 = { class: "ls-table" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["colspan"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["colspan"]
const _hoisted_18 = { key: 2 }
const _hoisted_19 = ["colspan"]
const _hoisted_20 = { "data-label": "Name" }
const _hoisted_21 = { "data-label": "Expected duration" }
const _hoisted_22 = { "data-label": "Investigation Categoty" }
const _hoisted_23 = { "data-label": "Status" }
const _hoisted_24 = { "data-label": "Actions" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_AddEditModal = _resolveComponent("AddEditModal")
  const _component_AuditTrail = _resolveComponent("AuditTrail")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchKeyword) = $event)),
              placeholder: "Search investigation type names"
            }, null, 512), [
              [_vModelText, _ctx.searchKeyword]
            ]),
            _hoisted_8
          ]),
          _createElementVNode("label", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.showActiveOnly) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.showActiveOnly]
            ]),
            _hoisted_10
          ]),
          _hoisted_11,
          _createElementVNode("button", {
            class: "btn btn-primary mr-2",
            onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.openAdd && _ctx.openAdd(...args)))
          }, " Add new investigation type ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("table", _hoisted_13, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", null, [
                _createElementVNode("div", null, _toDisplayString(h.text), 1)
              ]))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                _createElementVNode("td", {
                  colspan: _ctx.tableHeadings.length
                }, [
                  _createVNode(_component_LoadingIndicator)
                ], 8, _hoisted_15)
              ]))
            : (_ctx.errorLoadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                  _createElementVNode("td", {
                    colspan: _ctx.tableHeadings.length
                  }, [
                    _createVNode(_component_ErrorIndicator)
                  ], 8, _hoisted_17)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.investigationTypesTable.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                    _createElementVNode("td", {
                      colspan: _ctx.tableHeadings.length
                    }, "No Records", 8, _hoisted_19)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.investigationTypesTable.length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [], 64))
                  : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investigationTypesTable, (t) => {
            return (_openBlock(), _createElementBlock("tr", null, [
              _createElementVNode("td", _hoisted_20, _toDisplayString(t.name), 1),
              _createElementVNode("td", _hoisted_21, _toDisplayString(t.expectedDuration) + " days", 1),
              _createElementVNode("td", _hoisted_22, _toDisplayString(t.defaultInvestigationCategory.name), 1),
              _createElementVNode("td", _hoisted_23, _toDisplayString(t.status.name), 1),
              _createElementVNode("td", _hoisted_24, [
                _createElementVNode("button", {
                  class: "btn btn-default sml mr-2",
                  onClick: $event => (_ctx.openEdit(t))
                }, " Edit ", 8, _hoisted_25),
                _createElementVNode("button", {
                  class: "btn btn-default sml",
                  onClick: $event => (_ctx.openAuditTrail(t.name, t.id))
                }, " Audit Trail ", 8, _hoisted_26)
              ])
            ]))
          }), 256))
        ])
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary sml mt-2",
        onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.openAdd && _ctx.openAdd(...args)))
      }, " Add new investigation type ")
    ]),
    (_ctx.showAddEditModal)
      ? (_openBlock(), _createBlock(_component_AddEditModal, {
          key: 0,
          onCloseModal: _cache[4] || (_cache[4] = $event => (_ctx.showAddEditModal = false)),
          chosenInvestigationType: _ctx.chosenInvestigationType,
          onUpdateData: _ctx.getInvestigationTypes
        }, null, 8, ["chosenInvestigationType", "onUpdateData"]))
      : _createCommentVNode("", true),
    (_ctx.showAuditTrailModal)
      ? (_openBlock(), _createBlock(_component_AuditTrail, {
          key: 1,
          onCloseAuditTrailModal: _cache[5] || (_cache[5] = $event => {_ctx.showAuditTrailModal = false;}),
          investigationId: _ctx.chosenInvestigationId,
          investigationName: _ctx.chosenInvestigationName
        }, null, 8, ["investigationId", "investigationName"]))
      : _createCommentVNode("", true)
  ]))
}